import { map as rxjsmap } from 'rxjs';



import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FoodSafetyManualCompleteChecklist } from '../../shared/models/complete-checklist';
import { managetemperaturecontrol } from 'src/app/kuba/foodsafety/models/managetemperaturecontrol';
import { FoodControl } from './../models/food-control';
import { FoodControlOrder } from './../models/food-control-order';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ManualControlServices {
  key: any;
  constructor(private http: HttpClient) {}

  AssignFeatureId(): void {
    let workingModule = JSON.parse(sessionStorage.getItem('workingModule')).id;
    if (workingModule == 43) this.key = 'kubacontrol';
    else if (workingModule == 20) this.key = 'foodsafety';
  }

  getManualControlByParent(id: number) {
    this.AssignFeatureId();
    return this.http
      .get(environment.BASE_URL + '/' + this.key + '/foodcontrols/' + id).pipe(rxjsmap((result: any) => result));
  }

  getManualControlById(id: number) {
    this.AssignFeatureId();
    return this.http
      .get(environment.BASE_URL + '/' + this.key + '/foodcontrol/' + id).pipe(rxjsmap((result: any) => result));
  }

  createManualControl(foodSafety: FoodControl) {
    this.AssignFeatureId();
    return this.http
      .post(environment.BASE_URL + '/' + this.key + '/foodcontrol', foodSafety).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  updateManualControl(foodSafety: FoodControl) {
    this.AssignFeatureId();
    return this.http
      .put(environment.BASE_URL + '/' + this.key + '/foodcontrol', foodSafety).pipe(rxjsmap(result => result));
  }

  updateManualControlOrderNumber(foodSafety: FoodControlOrder[]) {
    this.AssignFeatureId();
    return this.http
      .put(
        environment.BASE_URL + '/foodsafety/foodcontrolOrderNumber',
        foodSafety
      ).pipe(rxjsmap(result => result));
  }

  deleteFoodControl(id: number) {
    this.AssignFeatureId();
    return this.http.delete(
      environment.BASE_URL + '/' + this.key + '/foodcontrol/' + id
    );
  }

  createCompleteChecklist(
    FoodSafetyManualCompleteChecklist: FoodSafetyManualCompleteChecklist
  ) {
    this.AssignFeatureId();
    return this.http
      .post(
        environment.BASE_URL + '/' + this.key + '/CompleteChecklistByFoodId',
        FoodSafetyManualCompleteChecklist
      ).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  deleteFoodControlAttachment(Id) {
    this.AssignFeatureId();
    return this.http
      .delete(
        environment.BASE_URL +
          '/' +
          this.key +
          '/deletefoodcontrolattachment/' +
          Id
      ).pipe(rxjsmap(result => result));
  }

  saveManageTempControl(manageTemperatureControl: managetemperaturecontrol) {
    this.AssignFeatureId();
    return this.http
      .post(
        `${environment.BASE_URL}/` + this.key + `/TempControl/Save`,
        manageTemperatureControl
      ).pipe(rxjsmap(result => result));
  }

  ManageTemperatureControl(foodSafetyId: number) {
    this.AssignFeatureId();
    return this.http
      .get(
        environment.BASE_URL +
          '/' +
          this.key +
          '/managetemperaturecontrol/' +
          foodSafetyId
      ).pipe(rxjsmap((result: any) => result));
  }

  updateKubaControlOrderNumber(control: FoodControlOrder[]) {
    this.AssignFeatureId();
    return this.http
      .put(environment.BASE_URL + '/kubacontrol/controlOrderNumber', control).pipe(rxjsmap(result => result));
  }
}
